import { createTheme } from '@mui/material'
import { ThemeProvider } from '@emotion/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import Loading from './components/Loading';
import cookies from './utilities/Cookies';
import { useDispatch } from 'react-redux';
import { updatedarkmode } from './features/mode';
import Users from './pages/Users';
import Calculator from './pages/Calculator';
import Disqualify from './pages/Disqualify';
import TurboForm from './pages/turbo-form/TurboForn';
import ResultPage from './pages/ResultPage';
import ADRTestForm from './pages/ADRTestForm';
import BuyerATYP from './pages/BuyerATYP';
import { BuyerDTYP } from './pages/BuyerDYP';
import TurboFormQP from './pages/turbo-form/TurboForn-QP';
import FormPageQP from './pages/array-form/FormQP';
import FormPageNVSL from './pages/array-form/FormNVSL';
import TurboFormNVSL from './pages/turbo-form/TurboForn-NVSL';
import DuplicateError from './pages/DuplicateError';
import AdrResultPage from './pages/AdrResultPage';
import TurboFormCL from './pages/turbo-form/TurboForn-CL';
import FormPageCl from './pages/array-form/FormCL';
import CustomerLabsTag from './components/CustomLabs';
import { DebtDisqualify } from './pages/DebtDisqualify';
import RouteChangeTracker from './components/scripts/RouteChangeTracker';
import { Cura } from './pages/cura/Cura';
import { CuraArray } from './pages/cura/CuraArray';
import BuyerBnCTYP from './pages/BuyerBnCTYP';
import FailedPage from './pages/Failed';
import CuraForm from './pages/cura-form/CuraForm';
import FCDR_TY from './pages/FCDR-TY';
import NDR_TY from './pages/NDR-TY';
import Lead from './pages/non-array-leads/Lead';
import LeadForm from './pages/non-array-leads/LeadForm';
import LeadArray from './pages/non-array-leads/LeadArray';
import LeadLoading from './pages/non-array-leads/LeadLoading';
import FCDRTY2 from './pages/FCDR-TY2';
import LeadFCDR from './pages/non-array-leads/LeadFCDR';
import FDR_TY from './pages/FDR-TY';
import CallLogs from './pages/CallLogs';
import ResultPage_Retell from './pages/ResultPage_Retell';
import AdrResultPage_Retell from './pages/AdrResultPage_Retell';
import FallbackForm from './pages/version-3/FallbackForm';
import LoadingPage from './pages/version-3/LoadingPage';
import FailedCredPull from './pages/version-3/FailedCredPull';
import AdrResultPage_Test from './pages/AdrResultPage_Test';
import CallLog from './pages/CallLog';
import FbConsentPage from './pages/FbConsentPage';
import TriggerCallPage from './pages/TriggerCallPage';
import RemoveWorkflowPage from './pages/RemoveWorkflowPage';
import NdrLeadsPage from './pages/NdrLeadsPage'
import MetricsDashboard from './pages/MetricsDashboard';
import Docs from './pages/Docs';
import TestEnvironment from './pages/TestEnvironment';
import DynamicBuyerPage from './pages/version-4/DynamicBuyerPage';
import VssDisqualify from './pages/VssDisqualify';
const Auth = lazy(() => import('./pages/Auth'))
const Form = lazy(() => import('./pages/array-form/Form'))
const Layout = lazy(() => import('./components/Layout'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const NotFound = lazy(() => import('./pages/NotFound'))


function App() {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#0067CF'
      },
      secondary: {
        main: '#7badf9'
      }
    },

    typography: {
      fontFamily: "generalsans regular",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightBold: 700,
      fontSize: 20
    }
  })

  const dispatch = useDispatch()

  useEffect(() => {
    let mode = cookies.getCookies('mode')
    if (mode !== '' && mode !== null && mode !== undefined) {
      dispatch(updatedarkmode({ dark: mode === 'light' ? false : true }))
    }
    // eslint-disable-next-line
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <CustomerLabsTag siteToken="cl79026oknmil0" />
      <Router>
        <RouteChangeTracker />
        <Routes>
          {/* CALL LOGS */}
          <Route exact path='/call/log/:contact_id' element={<Suspense fallback={<Loading />}><CallLog title={"Final Debt Relief - Call Logs"} /></Suspense>} />
          <Route exact path='/calls/logs/:contact_id' element={<Suspense fallback={<Loading />}><CallLogs title={"Final Debt Relief - Call Logs"} /></Suspense>} />

          {/* FB CONSENT */}
          <Route exact path='/fb-consent/:contact_id' element={<FbConsentPage title={"Final Debt Relief - Lead Consent"} />} />
          
          {/* LF ROUTES */}
          <Route exact path='/form-lf' element={<Suspense fallback={<Loading />}><Form title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* QP ROUTES */}
          <Route exact path='/form-qp' element={<Suspense fallback={<Loading />}><FormPageQP title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/turbo-form-qp' element={<Suspense fallback={<Loading />}><TurboFormQP title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* NVSL ROUTES */}
          <Route exact path='/form-nvsl' element={<Suspense fallback={<Loading />}><FormPageNVSL title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/turbo-form-nvsl' element={<Suspense fallback={<Loading />}><TurboFormNVSL title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* CL ROUTES */}
          <Route exact path='/form-cl' element={<Suspense fallback={<Loading />}><FormPageCl title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/turbo-form-cl' element={<Suspense fallback={<Loading />}><TurboFormCL title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* Routes for Under 20k */}
          <Route exact path='/lead' element={<Suspense fallback={<Loading />}><Lead title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/lead-form' element={<Suspense fallback={<Loading />}><LeadForm title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/lead-array' element={<Suspense fallback={<Loading />}><LeadArray title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/lead-fcdr' element={<Suspense fallback={<Loading />}><LeadFCDR title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/process' element={<Suspense fallback={<Loading />}><LeadLoading title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* THANK YOU PAGES */}
          <Route exact path='/adr-ty' element={<Suspense fallback={<Loading />}><BuyerATYP title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/fcdr-ty' element={<Suspense fallback={<Loading />}><FCDR_TY title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/fdr-ty' element={<Suspense fallback={<Loading />}><FDR_TY title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/fcdr-ty2' element={<Suspense fallback={<Loading />}><FCDRTY2 title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/ndr-ty' element={<Suspense fallback={<Loading />}><NDR_TY title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/turbo-ty' element={<Suspense fallback={<Loading />}><BuyerBnCTYP title={"Final Debt Relief - Thank You"} /></Suspense>} />
          <Route exact path='/cura-ty' element={<Suspense fallback={<Loading />}><BuyerDTYP title={"Final Debt Relief - Thank You"} /></Suspense>} />
          
          {/* RESULTS PAGES */}
          <Route exact path='/results' element={<Suspense fallback={<Loading />}><ResultPage title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/adr-results' element={<Suspense fallback={<Loading />}><AdrResultPage title={"Final Debt Relief - Complete application"} /></Suspense>} />
          {/* eslint-disable-next-line */}
          <Route exact path='/results-retell' element={<Suspense fallback={<Loading />}><ResultPage_Retell title={"Final Debt Relief - Complete application"} /></Suspense>} />
          {/* eslint-disable-next-line */}
          <Route exact path='/adr-results-retell' element={<Suspense fallback={<Loading />}><AdrResultPage_Retell title={"Final Debt Relief - Complete application"} /></Suspense>} />
          {/* eslint-disable-next-line */}
          <Route exact path='/results-test' element={<Suspense fallback={<Loading />}><AdrResultPage_Test title={"Final Debt Relief - Complete application"} /></Suspense>} />
          
          {/* V3 ROUTES */}
          <Route exact path='/fallback-form' element={<Suspense fallback={<Loading />}><FallbackForm title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/validating-data' element={<Suspense fallback={<Loading />}><LoadingPage title={"Final Debt Relief - Validating Data..."} /></Suspense>} />
          <Route exact path='/no-cred-re' element={<Suspense fallback={<Loading />}><FailedCredPull title={"Final Debt Relief - Almost there!."} /></Suspense>} />
          
          {/* V4 ROUTES */}
          <Route exact path='/dbp' element={<Suspense fallback={<Loading />}><DynamicBuyerPage title={"Final Debt Relief - Almost there!."} /></Suspense>} />

          {/* UNIVERSAL ROUTES */}
          <Route exact path='/cura' element={<Suspense fallback={<Loading />}><Cura title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/cura-array' element={<Suspense fallback={<Loading />}><CuraArray title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/adr' element={<Suspense fallback={<Loading />}><ADRTestForm title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/turbo-form' element={<Suspense fallback={<Loading />}><TurboForm title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/cura-form' element={<Suspense fallback={<Loading />}><CuraForm title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/dq' element={<Suspense fallback={<Loading />}><Disqualify title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/ddq' element={<Suspense fallback={<Loading />}><DebtDisqualify title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/vss-dq' element={<Suspense fallback={<Loading />}><VssDisqualify title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/fd' element={<Suspense fallback={<Loading />}><FailedPage title={"Final Debt Relief - Application Failed"} /></Suspense>} />
          <Route exact path='/dup-error' element={<Suspense fallback={<Loading />}><DuplicateError title={"Final Debt Relief - Complete application"} /></Suspense>} />
          <Route exact path='/calculator' element={<Suspense fallback={<Loading />}><Calculator title={"Final Debt Relief - Smart Savings Estimator Brief"} /></Suspense>} />
          <Route exact path='/' element={<Suspense fallback={<Loading />}><Auth title={"Access Account"} /></Suspense>} />
          <Route exact path='/auth' element={<Suspense fallback={<Loading />}><Auth title={"Access Account"} /></Suspense>} />
          <Route exact path='/dashboard' element={<Suspense fallback={<Loading />}><Layout /></Suspense>}>
            <Route exact path='' element={<Suspense fallback={<Loading />}><Dashboard title={"Dashboard | Final Debt Relief"} /></Suspense>} />
            <Route exact path='users' element={<Suspense fallback={<Loading />}><Users title={"Users | Final Debt Relief"} /></Suspense>} />
            <Route exact path='trigger-call' element={<TriggerCallPage title={"Trigger Call | Final Debt Relief"} />} />
            <Route exact path='workflow' element={<RemoveWorkflowPage title={"Remove Workflow | Final Debt Relief"} />} />
            <Route exact path='ndr-leads' element={<Suspense fallback={<Loading />}><NdrLeadsPage title={"NDR Leads | Final Debt Relief"} /></Suspense>} />
            <Route exact path='test-env' element={<TestEnvironment title={"Test Environment | Final Debt Relief"} />} />
          </Route>
          <Route exact path='/analytics' element={<MetricsDashboard title={"Analytics | Final Debt Relief"} />} />
          <Route exact path='/docs' element={<Docs title={"System Docs | Final Debt Relief"} />} />
          <Route exact path='*' element={<Suspense fallback={<Loading />}><NotFound /></Suspense>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
